import { useTranslation } from "react-i18next";
import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../../common/formatting/useDisplayDateWithTime";
import { isBidDeadlineStillOpen } from "../award/canSelectWinner";
import { effectiveBidDeadline } from "../qualification/stage";

export const useCompleteEvaluationDescription = (event: SourcingEventV2Dto): (() => string) => {
  const { t } = useTranslation();
  const displayDateWithTime = useDisplayDateWithTime();

  return () => {
    const frozen = t("The scores and the price selection are frozen. You can reopen it later.");
    const deadline = effectiveBidDeadline(event);
    if (deadline == null || !isBidDeadlineStillOpen(event, Date.now())) return frozen;
    const stillOpen = t(
      "The bid deadline {{date}} has not passed yet. Suppliers can still deliver or change their bids, and you can award only after the deadline.",
      { date: displayDateWithTime(deadline) },
    );
    return `${frozen} ${stillOpen}`;
  };
};
